import { useMutation } from "@tanstack/react-query";
import { api, queryClient } from "../context";
import { Doctor } from "../interfaces";
import { useNavigate } from "react-router-dom";

export const useReEnlistment = (requestId: string) => {
  const unenrollmentFn = (doctor: Doctor) => {
    return api<Doctor>({
      method: "PUT",
      url: "/doctors/unenrollment",
      data: { doctor },
    });
  };
  const navigate = useNavigate();
  return {
    reEnlistmentMutation: useMutation({
      mutationFn: unenrollmentFn,
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ["doctor"] });
        navigate(
          "/app/registro/firma-electronica-avanzada/validation-challenge",
          {
            state: {
              requestId,
            },
          },
        );
      },
      onError: (error) => {
        console.log("Error on unenrollment: ", error);
      },
    }),
  };
};
